import { useTranslation } from "react-i18next";
import {
  Money,
  Scales,
  CheckmarkFilled,
  Group,
  ChartBar,
} from "@carbon/icons-react";
import { SellerKpiResponse } from "../../../types";
import { createCurrencyCards, formatPercentage } from "../utils/kpiHelpers";
import StatCard from "../../carbon/StatCard/StatCard";
import "../kpiMetricGrid.scss";

interface SellerKpiMetricCardsProps {
  data: SellerKpiResponse;
}

const SellerKpiMetricCards = ({ data }: SellerKpiMetricCardsProps) => {
  const { t } = useTranslation();

  // Build cards array with separated currencies
  const cards = [
    ...createCurrencyCards(
      t("analytics.totalSales"),
      data.totalSoldByCurrency,
      Money,
      t("analytics.totalSalesDesc")
    ),
    {
      name: t("analytics.numberOfClients"),
      value: (data.numberOfClients ?? 0).toLocaleString(),
      icon: Group,
      description: t("analytics.numberOfClientsDesc"),
    },
    {
      name: t("analytics.auctionsWon"),
      value: (data.auctionsWon ?? 0).toLocaleString(),
      icon: CheckmarkFilled,
      description: t("analytics.auctionsWonDesc"),
    },
    {
      name: t("analytics.auctionsParticipated"),
      value: (data.auctionsParticipated ?? 0).toLocaleString(),
      icon: Scales,
      description: t("analytics.auctionsParticipatedDesc"),
    },
    {
      name: t("analytics.closingRate"),
      value: formatPercentage(data.winRate ?? 0),
      icon: ChartBar,
      description: t("analytics.closingRateDesc"),
    },
  ];

  return (
    <div className="kpi-metric-grid">
      {cards.map((card, index) => (
        <StatCard
          key={`${card.name}-${index}`}
          label={card.name}
          value={card.value}
          caption={card.description}
          icon={card.icon}
        />
      ))}
    </div>
  );
};

export default SellerKpiMetricCards;
